import { useState } from 'react';
import { Link } from 'react-router-dom';
import { KNOWLEDGE_ARTICLES } from '../data/knowledgeArticles';
import { COMPANY_INFO } from '../data/staticData';
import ContactForm from '../components/ContactForm';
import { imageUrl } from '../lib/images';

export default function KnowledgePage() {
  const [activeTab, setActiveTab] = useState('Alle');
  const [visibleCount, setVisibleCount] = useState(12);
  const [openRoofFaq, setOpenRoofFaq] = useState([0]);
  const [openEnergyFaq, setOpenEnergyFaq] = useState([0]);

  const roofFaqs = [
    {
      q: 'Hvad koster et nyt tag?',
      a: (
        <div className="space-y-3">
          <p>
            Prisen på et nyt tag afhænger af tagtype, størrelse, konstruktion og adgangsforhold. Når man undersøger prisen på nyt tag, er det især materialevalg og tagets kompleksitet, der spiller ind. De fleste parcelhuse ligger typisk i et samlet spænd fra ca. 120.000 kr. og op, men det kan både være lavere og højere afhængigt af forholdene.
          </p>
          <div className="overflow-x-auto my-2">
            <table className="min-w-full text-xs border border-stone-200">
              <thead className="bg-stone-100 font-bold text-stone-900 border-b border-stone-200">
                <tr>
                  <th className="p-2 text-left">Tagtype</th>
                  <th className="p-2 text-left">Typisk pris pr. m²</th>
                  <th className="p-2 text-left">Forventet levetid</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-stone-200 text-stone-700">
                <tr><td className="p-2 font-medium">Betontagsten</td><td className="p-2">ca. 900–1.400 kr.</td><td className="p-2">30–40 år</td></tr>
                <tr><td className="p-2 font-medium">Tegltag</td><td className="p-2">ca. 1.200–1.800 kr.</td><td className="p-2">50+ år</td></tr>
                <tr><td className="p-2 font-medium">Tagpap</td><td className="p-2">ca. 800–1.400 kr.</td><td className="p-2">30–50 år</td></tr>
                <tr><td className="p-2 font-medium">Ståltag</td><td className="p-2">ca. 700–1.200 kr.</td><td className="p-2">30–40 år</td></tr>
                <tr><td className="p-2 font-medium">Skifer</td><td className="p-2">ca. 1.600–2.500 kr.</td><td className="p-2">60+ år</td></tr>
              </tbody>
            </table>
          </div>
          <p className="text-xs text-stone-500 italic">
            Priserne er vejledende og afhænger af konstruktion, undertag, isolering, stillads m.m.
          </p>
          <p>
            Har du prøvet vores{' '}
            <Link to="/prisberegner" className="text-[#BE0F12] font-bold underline">
              prisberegner
            </Link>
            ? Her kan du få en mere konkret pris på netop dit tagprojekt.
          </p>
        </div>
      )
    },
    {
      q: 'Hvilken type tag er den bedste til min bolig?',
      a: (
        <div className="space-y-2">
          <p>
            Der findes mange forskellige tagtyper, som alle har deres forskellige styrker. Valg af type, materiale, farve, glasur mv. handler derfor alt sammen om dine krav og prioriteringer – samt hvad der vil være bedst for dit hus.
          </p>
          <p>
            Derfor er det vigtigt, at du afgør med dig selv, hvad der er det vigtigste for dig og dit tag, hvor du her bør overveje aspekter som: Pris, kvalitet, holdbarhed, udseende, monteringsproces og miljøbevidsthed. Vi anbefaler derfor altid, at man sætter sig ind i de forskellige tagtyper eller spørger en fagekspert om råd, hvis du har brug for yderligere viden og vejledning.
          </p>
          <p>
            <Link to="/nyt-tag" className="text-[#BE0F12] font-bold underline">
              Læs mere om de forskellige tagtyper her.
            </Link>
          </p>
        </div>
      )
    },
    {
      q: 'Hvornår er det nødvendigt at skifte taget på min bolig?',
      a: (
        <div className="space-y-2">
          <p>
            Et tags levetid afhænger af flere forhold, og det kan derfor være svært at sige præcist, hvor lang tid et tag kan holde, før det er tid til en udskiftning. Et tæt tag er dog nødvendigt for et sundt hus og indeklima, hvorfor det altid kan betale sig at udskifte eller reparere taget, hvis det er utæt eller skadet.
          </p>
          <p>
            Står I overfor en større ombygning, tilbygning eller renovering kan man også med fordel skifte taget samtidig. Vi anbefaler dog altid, at I tager en fagekspert med på råd, som kan komme og tilse tagets stand.{' '}
            <Link to="/viden/hvordan-vedligeholder-jeg-bedst-mit-tag" className="text-[#BE0F12] font-bold underline">
              Læs mere her.
            </Link>
          </p>
        </div>
      )
    },
    {
      q: 'Hvilke fordele er der ved at få nyt tag?',
      a: (
        <div className="space-y-2">
          <p>
            Du står måske i overvejelsesfasen, hvor du overvejer at få nyt tag, og er der flere fordele, som taler for investeringen i et nyt tag. Ikke nok med, at et nyt tag kan give et smukkere og mere indbydende hus, har det også økonomiske fordele, da du kan spare penge på varmeregningen med et energirigtigt tag. Det er altsammen med til at øge husets salgsværdi samt skabe et bedre og mere stabilt indeklima for dig og din familie.
          </p>
          <p>
            <Link to="/viden/hvordan-vedligeholder-jeg-bedst-mit-tag" className="text-[#BE0F12] font-bold underline">
              Læs mere om, hvordan du kan forlænge tagets levetid her
            </Link>{' '}
            eller{' '}
            <a href="#kontakt" className="text-[#BE0F12] font-bold underline">
              kontakt os for at høre mere om, hvordan et nyt tag kan være en investering i din bolig.
            </a>
          </p>
        </div>
      )
    },
    {
      q: 'Hvor lang tid tager det at lave et nyt tag?',
      a: (
        <p>
          Det behøver ikke at tage lang tid at få skiftet boligens tag, og det kan ofte gøres på 2-4 uger fra start til slut, afhængigt af opgavens omfang. I denne periode vil vi arbejde så effektivt som muligt og være så lidt til gene, som overhovedet muligt. Har du en deadline, som vi skal forsøge at arbejde inden for, kan du med fordel oplyse dette, når du kontakter os, så vil vi altid gøre vores bedste for at imødekomme dette.
        </p>
      )
    }
  ];

  const energyFaqs = [
    {
      q: 'Hvad koster det at få efterisoleret?',
      a: (
        <p>
          Prisen på isolering af loftsrum afhænger af, hvor mange kvadratmeter dit loft er i grundplan. Derudover skal vi vide, hvor lang gangbroen er, og hvor mange lag isolering, du ønsker. Her kan du vælge mellem 100-450 mm, hvor det nuværende krav til boliger dog er, at der skal være minimum 300 mm. isolering og 400 mm. for lavenergihuse.{' '}
          Har du prøvet vores{' '}
          <Link to="/prisberegner-isolering" className="text-[#BE0F12] font-bold underline">
            prisberegner
          </Link>
          ? Her kan du få en mere konkret pris på isolering af dit hus.
        </p>
      )
    },
    {
      q: 'Hvorfor er det en god idé at få efterisoleret sin bolig?',
      a: (
        <p>
          Vi anbefaler som udgangspunkt, at du sørger for at efterisolere dit loft, hvis der er mindre end 175 mm. isolering. Det gælder for stort set alle ældre huse, der er mere end 10 år gamle, og som aldrig har fået lagt ekstra isolering ind. Står I overfor en større ombygning, tilbygning eller renovering kan man også med fordel få efterisoleret i samme omgang, da isolering er en investering i boligens samlede værdi.{' '}
          <Link to="/energiloesninger" className="text-[#BE0F12] font-bold underline">
            Læs mere om fordelene ved isolering af huset her.
          </Link>
        </p>
      )
    },
    {
      q: 'Hvorfor skal jeg skifte boligens vinduer/døre?',
      a: (
        <p>
          Har du vinduer, der er meget slidte, medtagede eller ligefrem i stykker, kan det sjældent betale sig at restaurere dem. Udover at det tidsmæssigt – og ofte også økonomisk – ikke sparer dig for penge, så vil de ældre vinduer ikke leve op til nutidens energikrav. Står du i en sådan situation, eller oplever du gener, herunder træk, dug på indersiden, nedslidt eller råddent træ, kan du med fordel skifte dine vinduer og/eller døre. Nye vinduer/døre vil foruden at give et nyt, mere moderne look til huset, også mindske din varmeregning markant.
        </p>
      )
    },
    {
      q: 'Hvordan påvirker mit nye tag varmeforbruget i min bolig?',
      a: (
        <p>
          Fokusset på energirenovering og -optimering af boligen er højere end nogensinde, og der findes flere muligheder for at spare både klima og pengepung for unødig energi. Faktisk sker omtrent 25 % af varmetabet i en almindelig husstand gennem loftet og taget, hvorfor nyt tag, efterisolering samt energirigtige vinduer/døre er en rigtig god idé at investere i. Der kan som regel altid gøres noget for at energioptimere en bolig, og vi anbefaler, at man tager fat i professionelle fagfolk, som kan tilse boligens stand og rådgive i de rigtige løsninger.
        </p>
      )
    },
    {
      q: 'Hvad er kravene til energioptimering i dag?',
      a: (
        <p>
          Reglerne til energioptimering af boligen er strammere i dag, og som husejere er det dit ansvar, at du lever op til kravene. Det kræves i dag, at alle husejere, som bygger nyt, bygger til eller bygger om, bruger vinduer, der svarer til energiklasse A, hvilket normalt er 3-lags glas eller såkaldte A-mærkede vinduer. B-mærkede elementer med 2-lags glas er kun tilladt i sommerhuse og uopvarmede rum. Samtidig er der krav om minimum 300 mm. isolering i alm. huse og 400 mm. for lavenergihuse.
        </p>
      )
    }
  ];

  const toggleRoof = (i) => {
    setOpenRoofFaq((prev) =>
      prev.includes(i) ? prev.filter((idx) => idx !== i) : [...prev, i]
    );
  };

  const toggleEnergy = (i) => {
    setOpenEnergyFaq((prev) =>
      prev.includes(i) ? prev.filter((idx) => idx !== i) : [...prev, i]
    );
  };

  const filteredArticles = KNOWLEDGE_ARTICLES.filter((article) => {
    if (activeTab === 'Video') return !!article.videoId;
    if (activeTab === 'Artikler') return !article.videoId;
    return true;
  });

  const displayedArticles = filteredArticles.slice(0, visibleCount);

  return (
    <div className="bg-white">
      {/* Sektion 1: Hos os er der ingen dumme spørgsmål */}
      <section className="py-12 sm:py-16 lg:py-20 bg-stone-50 border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          <div className="max-w-4xl">
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 tracking-tight uppercase">
              Hos os er der ingen dumme spørgsmål
            </h1>
            <p className="text-stone-700 text-base sm:text-lg mt-3 leading-relaxed">
              Få svar på de vigtigste spørgsmål om tagudskiftning, tagtyper, levetid, efterisolering og energirigtige løsninger.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            {/* Tag FAQ */}
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <h2 className="text-xl sm:text-2xl font-extrabold text-stone-900 uppercase">
                  Tag:
                </h2>
                <span className="text-xs font-bold text-stone-500 uppercase tracking-wider bg-stone-100 px-3 py-1 border border-stone-200">
                  Tagløsninger
                </span>
              </div>
              <div className="space-y-3">
                {roofFaqs.map((faq, idx) => {
                  const isOpen = openRoofFaq.includes(idx);
                  return (
                    <div key={idx} className="bg-white border border-stone-200">
                      <button
                        onClick={() => toggleRoof(idx)}
                        className="w-full py-4 px-6 text-left flex justify-between items-center gap-4 hover:bg-stone-50 transition-colors"
                      >
                        <span className="font-bold text-stone-900 text-sm sm:text-base">
                          {faq.q}
                        </span>
                        <span className="text-[#BE0F12] font-black text-lg shrink-0">
                          {isOpen ? '−' : '+'}
                        </span>
                      </button>
                      {isOpen && (
                        <div className="px-6 pb-5 pt-1 text-stone-700 text-sm leading-relaxed border-t border-stone-100">
                          {faq.a}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Viden Tag Billede */}
              <div className="pt-2">
                <img
                  src={imageUrl('/_assets/scraped-3.webp', 'width=800,quality=80,format=auto')}
                  alt="Taglægning af teglsten"
                  className="w-full h-56 sm:h-64 object-cover border border-stone-200 shadow-sm"
                />
              </div>
            </div>

            {/* Energiløsninger FAQ */}
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <h2 className="text-xl sm:text-2xl font-extrabold text-stone-900 uppercase">
                  Energiløsninger:
                </h2>
                <span className="text-xs font-bold text-stone-500 uppercase tracking-wider bg-stone-100 px-3 py-1 border border-stone-200">
                  Efterisolering & Energi
                </span>
              </div>
              <div className="space-y-3">
                {energyFaqs.map((faq, idx) => {
                  const isOpen = openEnergyFaq.includes(idx);
                  return (
                    <div key={idx} className="bg-white border border-stone-200">
                      <button
                        onClick={() => toggleEnergy(idx)}
                        className="w-full py-4 px-6 text-left flex justify-between items-center gap-4 hover:bg-stone-50 transition-colors"
                      >
                        <span className="font-bold text-stone-900 text-sm sm:text-base">
                          {faq.q}
                        </span>
                        <span className="text-[#BE0F12] font-black text-lg shrink-0">
                          {isOpen ? '−' : '+'}
                        </span>
                      </button>
                      {isOpen && (
                        <div className="px-6 pb-5 pt-1 text-stone-700 text-sm leading-relaxed border-t border-stone-100">
                          {faq.a}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Viden Energiløsninger Billede */}
              <div className="pt-2">
                <img
                  src={imageUrl('/_assets/scraped-7.webp', 'width=800,quality=80,format=auto')}
                  alt="Tømrer på tag med tagplader"
                  className="w-full h-56 sm:h-64 object-cover border border-stone-200 shadow-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sektion 2: Dyk ned i vores vidensbank */}
      <section className="py-16 sm:py-20 bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="space-y-4">
            <h2 className="text-2xl sm:text-4xl font-extrabold text-stone-900 uppercase">
              Dyk ned i vores vidensbank
            </h2>
            <div className="flex gap-2">
              {['Alle', 'Video', 'Artikler'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => {
                    setActiveTab(tab);
                    setVisibleCount(12);
                  }}
                  className={`px-6 py-2 font-bold text-sm uppercase tracking-wider transition-colors ${
                    activeTab === tab
                      ? 'bg-[#BE0F12] text-white'
                      : 'bg-stone-100 text-stone-700 hover:bg-stone-200'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {displayedArticles.map((article) => (
              <article
                key={article.slug}
                className="bg-white border border-stone-200 overflow-hidden shadow-sm flex flex-col justify-between hover:shadow-md transition-shadow group"
              >
                <div>
                  <div className="h-52 overflow-hidden relative bg-stone-100">
                    <img
                      src={imageUrl(article.image, 'width=600,quality=80,format=auto')}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    {article.videoId && (
                      <div className="absolute bottom-3 right-3 px-2 py-1 bg-stone-900/90 text-white text-[11px] font-bold flex items-center gap-1.5">
                        <i className="fa-solid fa-play text-[#BE0F12]"></i>
                        <span>Med video</span>
                      </div>
                    )}
                  </div>

                  <div className="p-6 space-y-2">
                    <div className="flex justify-between items-center text-xs text-stone-500">
                      {article.category ? (
                        <span className="font-bold text-[#BE0F12] uppercase tracking-wider">
                          {article.category}
                        </span>
                      ) : (
                        <span></span>
                      )}
                      {article.date && <span>Udgivet: {article.date}</span>}
                    </div>
                    <h3 className="text-xl font-bold text-stone-900 group-hover:text-[#BE0F12] transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-stone-600 line-clamp-3 leading-relaxed">
                      {article.meta_description}
                    </p>
                  </div>
                </div>

                <div className="p-6 pt-0">
                  <Link
                    to={`/viden/${article.slug}`}
                    className="w-full py-2.5 px-4 bg-stone-100 hover:bg-stone-900 text-stone-900 hover:text-white font-bold text-xs flex items-center justify-center gap-2 transition-colors uppercase"
                  >
                    <span>Se hele projektet</span>
                    <i className="fa-solid fa-arrow-right text-xs"></i>
                  </Link>
                </div>
              </article>
            ))}
          </div>

          {/* Indlæs flere knap hvis der er flere artikler end vist */}
          {visibleCount < filteredArticles.length && (
            <div className="text-center pt-4">
              <button
                onClick={() => setVisibleCount((prev) => prev + 12)}
                className="px-8 py-3.5 bg-stone-900 hover:bg-black text-white font-bold text-xs tracking-wider uppercase transition-colors"
              >
                Indlæs flere
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Kontakt os og få den rette rådgivning */}
      <section className="py-12 bg-white text-center border-b border-stone-200">
        <div className="max-w-4xl mx-auto px-4 space-y-4">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 uppercase">
            Kontakt os og få den rette rådgivning
          </h2>
          <div>
            <a
              href="#kontakt"
              className="inline-block px-8 py-3.5 bg-[#BE0F12] hover:bg-[#a00d0f] text-white font-bold text-sm tracking-wider uppercase transition-colors"
            >
              Kontakt os
            </a>
          </div>
        </div>
      </section>

      {/* Bund: Anmeldelser og Kontaktformular (som på originalen) */}
      <section id="kontakt" className="py-16 sm:py-24 bg-stone-100 scroll-mt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 sm:gap-16 items-start">
            
            {/* Venstre kolonne: Firmaoplysninger og Anmeld Håndværker */}
            <div className="lg:col-span-5 space-y-8">
              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-3">
                <div className="flex items-center gap-1 text-amber-500 text-lg">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                </div>
                <a
                  href="https://www.anmeld-haandvaerker.dk/tagdaekker/dansk-tagbyg-aps"
                  target="_blank"
                  rel="noreferrer"
                  className="block font-black text-xl text-stone-900 hover:text-[#BE0F12] transition-colors"
                >
                  4,8 ud af 155 anmeldelser
                </a>
                <p className="text-xs text-stone-500">
                  Finalist til Årets Håndværker 5 år i træk
                </p>
              </div>

              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-4 text-sm text-stone-700">
                <h3 className="font-extrabold text-xl text-stone-900 uppercase">
                  Dansk Tagbyg ApS
                </h3>
                <div className="space-y-2">
                  <p>
                    <strong className="text-stone-900">Ring:</strong>{' '}
                    <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.phoneFormatted}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Skriv:</strong>{' '}
                    <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.email}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Adr:</strong> {COMPANY_INFO.address}
                  </p>
                  <p>
                    <strong className="text-stone-900">CVR:</strong> {COMPANY_INFO.cvr}
                  </p>
                </div>
                <div className="pt-3 border-t border-stone-200">
                  <p className="font-bold text-stone-900">Vi løser opgaver i hele DK</p>
                </div>
                <div className="pt-2">
                  <p className="text-xs font-bold text-stone-500 uppercase tracking-wider mb-2">Vi er medlem af</p>
                  <div className="flex flex-wrap gap-2 text-xs font-semibold text-stone-700">
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">Swisspearl</span>
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">Byg Garanti</span>
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">DI Byggeri</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Højre kolonne: Kontaktformular */}
            <div className="lg:col-span-7 bg-white border border-stone-200 p-8 sm:p-10 shadow-sm">
              <ContactForm idPrefix="knowledge" submitButtonText="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
